import type { ReactionAPIResponse } from "@/models/reaction-api-response";

interface FetchReactionDetailsResult {
  data: ReactionAPIResponse | null;
  error: Error | null;
  status: number;
}

export async function fetchReactionDetails(
  contentId: string,
): Promise<FetchReactionDetailsResult> {
  let error: Error | null = null;
  let status = 500;
  const data = await $fetch<ReactionAPIResponse>(
    `${import.meta.env.VITE_API_BASE_URL}/content/reaction`,
    {
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
        Accept: "application/json",
      },
      params: { contentid: contentId },
      onResponse({ response }) {
        status = response.status;
      },
      onResponseError({ response, error: responseError }) {
        status = response._data.code;
        error = responseError ?? null;
      },
    },
  );
  return {
    data: data ?? null,
    error: error,
    status: status,
  };
}
